<template>
  <div class="home" v-if="activeMode">
    <BackButton @click="goBack" />
    <div class="headDeposit">
      <img :src="require(`@/assets/icons/${getImgName(currency)}.svg`)" />
      <p>
        {{ isCard ? $t("bankCard") : getCurrencyName(currency) }}, <span>{{ currency }}</span>
      </p>
    </div>
    <div class="depositBlock">
      <input class="timeInput" v-model="selectedAmount" :placeholder="$t('withdrawPlaceholder') + userCurrency" />
      <input class="timeInput" v-model="selectedReqs" :placeholder="isCard ? $t('depositCardNumber') : $t('depositCardAddress')" />
      <button class="timeAcceptButton" :class="selectedAmount != '' ? 'active' : ''" @click="goPayment">
        <span class="loader" v-if="isLoader"></span>
        <p v-else>{{ $t("continue") }}</p>
      </button>
    </div>
  </div>
  <Transition name="fade">
    <NotifyComponent :timely="false" :duration="3" :notify="notifyText" v-if="isShowNotify" @closeNotify="isShowNotify = false" />
  </Transition>
</template>

<script>
import { BackButton } from "vue-tg";
import NotifyComponent from "./NotifyComponent.vue";
import axios from "axios";
import { UserManager } from "@/utils/userManager";
import { translateApiError } from "@/utils/apiErrors";
export default {
  name: "DepositComponent",
  data() {
    return {
      activeMode: null,
      currency: "",
      isCard: true,
      selectedAmount: "",
      selectedReqs: "",
      isCardData: false,
      ru: "ru",
      notifyText: "",
      isShowNotify: false,
      timerMinutes: 5,
      timerSeconds: 0,
      isLoader: false,
      timer: null,

      user: null,
      botId: null,
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    initializeUser() {
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;
      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
      }
    },
    goPayment() {
      if (this.selectedAmount.length == 0 || this.selectedReqs.length == 0) return this.showNotify(this.$t("emptyArea"));
      this.isLoader = true;
      axios
        .post(`${window.location.origin}/withdrawal/make`, {
          user_id: this.user.id,
          bot_id: this.botId,
          // currency: this.currency,
          amount: Number(this.selectedAmount),
          method: this.activeMode.includes("card") ? "card" : this.activeMode,
          // payment_details: "RUB",
          payment_details: this.selectedReqs,
        })
        .then((res) => {
          console.log(res);
          this.showNotify(this.$t("withdrawSuccess"));
          this.isLoader = false;
          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
        })
        .catch((err) => {
          console.log(err);
          this.showNotify(translateApiError(this.$t.bind(this), err.response?.data?.detail));
          this.isLoader = false;
        });
      // setTimeout(() => {
      //   this.isCardData = true
      //   this.startTimer()
      // }, 500)
    },
    changeActive() {
      this.activeMode == "deposit" ? (this.activeMode = "withdraw") : (this.activeMode = "deposit");
    },
    copyText(event) {
      let info = event.target.closest(".dataBlock").querySelector(".blockValue").innerText;
      navigator.clipboard.writeText(info).then(() => {
        this.showNotify(this.$t("notifyCopyText"));
      });
    },
    showNotify(text) {
      this.notifyText = text;
      this.isShowNotify = true;
    },
    closeNotify() {
      this.isShowNotify = false;
    },
    checkPayment() {
      this.showNotify(this.$t("notifyPaymentNotFound"));
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timerSeconds - 1 == -1) {
          this.timerMinutes -= 1;
          this.timerSeconds = 60;
        }
        this.timerSeconds -= 1;
        if (this.timerMinutes == 0 && this.timerSeconds == 0) clearInterval(this.timer);
      }, 1000);
    },
    getCurrencyName(cur) {
      switch (cur) {
        case "BTC":
          return "Bitcoin";
        case "ETH":
          return "Ethereum";
        case "USDT":
          return "Tether";
      }
    },
    getImgName(cur) {
      switch (cur) {
        case "RUB":
          return "ru";
        case "UAH":
          return "ua";
        case "KZT":
          return "kz";
        case "BTC":
          return "bitcoin";
        case "ETH":
          return "ethereum";
        case "USDT":
          return "tether";
      }
    },
  },
  mounted() {
    this.activeMode = this.$route.params.id;
    this.userCurrency = this.$store.getters.getCurrency;
    this.activeMode.includes("card") ? ((this.currency = this.activeMode.split("_")[1].toUpperCase()), (this.isCard = true)) : ((this.currency = this.activeMode.toUpperCase()), (this.isCard = false));
    this.initializeUser();
  },
  components: { BackButton, NotifyComponent },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
}
.headDeposit {
  display: flex;
  gap: 10px;
  align-items: center;
}
.headDeposit p {
  font-size: 17px;
}
.depositBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.timeInput {
  width: 100%;
  background-color: var(--button-background);
  border-radius: 10px;
  border: 0;
  padding: 13px;
  font-size: 17px;
  font-weight: 400;
  outline: none;
  color: var(--text-color1);
}
.timeAcceptButton {
  background-color: #007aff;
  border-radius: 10px;
  padding: 15px;
  color: var(--button-text-color);
  border: 0;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeAcceptButton.active {
  opacity: 1;
}
.cardData {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.dataBlock {
  background-color: var(--second-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-radius: 10px;
}
.blockInfo {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 90%;
}
.blockHead {
  color: #808080;
  font-size: 15px;
}
.blockValue {
  font-size: 17px;
  color: var(--black-to-white);
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  mask-image: linear-gradient(to right, black 80%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, black 80%, transparent 100%);
}
.checkPayment {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.checkPayment p {
  color: #8d8d8e;
}
.checkPayment p span {
  color: #bababb;
}
.loader {
  border: 3px solid white;
  border-bottom-color: transparent;
  width: 20px;
  height: 20px;
  display: flex;
  border-radius: 50%;
  animation: rotation 1s linear infinite;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
